import { openRegister } from '@/components/auth/open-auth'
import { SmartTooltip } from '@/components/extension/smart-tooltip'
import { useUserQuery } from '@/hooks/react-query/user/use-user'
import { formatPrice } from '@/lib/utils'
import { InfoIcon } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

interface ProductInfoCoolclubPricingProps {
  coolclubPrice: number
  rankingsText: string
}

export const ProductInfoCoolclubPricing: React.FC<
  ProductInfoCoolclubPricingProps
> = ({ coolclubPrice, rankingsText }) => {
  const { data: user } = useUserQuery()
  const t = useTranslations('product_detail.title')
  const tCommon = useTranslations()

  if (user) return null

  const tooltipContent = t('coolclub_price', {
    rankings: rankingsText,
  })

  return (
    <div className='mt-4 flex items-center justify-between rounded-lg bg-[#F1F3FF] px-5 py-2 text-sm'>
      <div className='flex items-center gap-2'>
        <Image
          src='/icons/icon-coolcash-box.svg'
          alt='Coolcash'
          width={16}
          height={16}
          unoptimized
          className='h-4 w-4'
        />
        <div className='flex items-center gap-1'>
          <div>{t('coolclub_price_label')}:</div>
          <div className='font-medium'>{formatPrice(coolclubPrice)}</div>
          <SmartTooltip content={tooltipContent} side='top' trigger='click'>
            <InfoIcon className='h-3.5 w-3.5' />
          </SmartTooltip>
        </div>
      </div>
      <div
        onClick={() => {
          openRegister()
        }}
        className='ml-0 cursor-pointer text-sm font-medium text-primary underline'
      >
        {tCommon('button.register_now')}!
      </div>
    </div>
  )
}
